"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deletedSubdocuments = exports.hydratedPropertySelector = void 0;
const entities_1 = require("@travelnest/entities");
/**
 * A selector function to retrieve an IProperty with all of its subdocuments attached from the redux store.
 * @param state The redux store
 * @param propertyId The id of the property
 *
 * @returns IProperty | null
 */
const hydratedPropertySelector = (state, propertyId) => {
    const property = state.data.properties.byId[propertyId];
    const amenitiesByProperty = (0, entities_1.memoizedGroupBySelector)('property', state.data.amenities.byId);
    const bathroomsByProperty = (0, entities_1.memoizedGroupBySelector)('property', state.data.bathrooms.byId);
    const bedsByProperty = (0, entities_1.memoizedGroupBySelector)('property', state.data.beds.byId);
    const localLicenceByProperty = (0, entities_1.memoizedGroupBySelector)('property', state.data.localLicence.byId);
    const restrictionsByProperty = (0, entities_1.memoizedGroupBySelector)('property', state.data.restrictions.byId);
    const propertyLocalLicence = localLicenceByProperty[propertyId] ? localLicenceByProperty[propertyId][0] : null;
    if (property) {
        return Object.assign(Object.assign({}, property), { amenities: amenitiesByProperty[propertyId] || [], bathrooms: bathroomsByProperty[propertyId] || [], beds: bedsByProperty[propertyId] || [], local_licence: propertyLocalLicence, restrictions: restrictionsByProperty[propertyId] || [] });
    }
    else {
        return null;
    }
};
exports.hydratedPropertySelector = hydratedPropertySelector;
const SUBDOCUMENT_ARRAY_KEYS = ['amenities', 'beds', 'bathrooms', 'restrictions'];
/**
 * Get an object containing subdocuments that have been removed between instances of an IProperty
 * @param previous IProperty: The property to compare as current state (with potentially deleted elements)
 * @param next IProperty: The property to use to determine which entities are no longer present
 *
 * @returns An object containing any deleted subdocuments
 */
const deletedSubdocuments = (previous, next) => {
    const subdocuments = {};
    SUBDOCUMENT_ARRAY_KEYS.forEach((subdocumentKey) => {
        const nextEntities = next[subdocumentKey] || [];
        const nextById = (0, entities_1.keyEntitiesBy)(nextEntities, 'id');
        const previousEntities = previous[subdocumentKey] || [];
        const deleted = previousEntities.filter((prevEntity) => nextById[prevEntity.id] === undefined);
        if (deleted.length) {
            subdocuments[subdocumentKey] = deleted;
        }
    });
    if (next.local_licence === null && previous.local_licence !== null) {
        subdocuments.local_licence = previous.local_licence;
    }
    return subdocuments;
};
exports.deletedSubdocuments = deletedSubdocuments;
//# sourceMappingURL=helpers.js.map